<!-- Start Navbar Section -->
<nav class="navbar navbar-expand-lg navbar-light px-4 d-flex align-items-center py-2">
    <a class="navbar-brand" [routerLink]="'/home'">
        <img routerLink="home" [src]="'assets/images/STC_logo.svg'" class="stc-logo" />
    </a>
    <button
        (click)="isCollapsed = !isCollapsed"
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span class="navbar-toggler-icon"></span>
    </button>
    <div [class.show]="!isCollapsed" class="collapse navbar-collapse justify-content-between" id="navbarNav">
        <ul class="navbar-nav">
            <li *ngFor="let menuItem of dynamicMenuList" class="nav-item dropdown">
                <a
                    class="nav-link menu-item"
                    routerLinkActive="active-menu-item"
                    [routerLinkActiveOptions]="{ exact: false }"
                    [routerLink]="menuItem.path"
                    *ngIf="!menuItem.subItems"
                    (click)="onMenuClick(menuItem)"
                    >{{ menuItem.name | translate }}</a
                >
                <a
                    class="nav-link dropdown-toggle"
                    *ngIf="menuItem?.subItems?.length > 0 && menuItem.name !== 'notAllowed'"
                    data-bs-toggle="dropdown"
                    role="button"
                    aria-expanded="false"
                    (click)="onMenuClick(menuItem)"
                >
                    {{ menuItem.name | translate }}
                </a>

                <ul *ngIf="menuItem.subItems && menuItem?.subItems?.length > 0" class="dropdown-menu">
                    <li *ngFor="let subItem of menuItem.subItems">
                        <a class="dropdown-item" [routerLink]="subItem.path" (click)="onMenuClick(subItem)">{{ subItem.name | translate }}</a>
                    </li>
                </ul>
            </li>
        </ul>
        <!-- Message Center and Profile -->
        <ul class="navbar-nav d-sm-flex align-items-center d-block">
            <li class="nav-item" *ngIf="loggedInUserService.canAccessMessageCenter()">
                <a
                    class="nav-link menu-item"
                    routerLinkActive="active-menu-item"
                    [routerLinkActiveOptions]="{ exact: false }"
                    (click)="isCollapsed = !isCollapsed"
                    [routerLink]="'/message-center'"
                >
                    <img src="assets/icons/message.png" />
                    {{ 'ticketing' | translate }}</a
                >
            </li>
            <li class="nav-item dropdown profile-dropdown">
                <a
                    class="nav-link dropdown-toggle d-sm-flex align-items-center d-block gap-2"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <img class="rounded-circle mx-2 user-image" [src]="loggedInUserDetails.image" onerror="this.src='assets/images/user2.jpg'" />

                    <!-- <span class="welcome-message">{{ 'welcome' | translate }}</span> -->
                    <span
                        class="d-inline-block text-truncate"
                        style="max-width: 150px"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="{{ loggedInUserDetails | getValueByLang }}"
                        >{{ loggedInUserDetails | getValueByLang }}</span
                    >
                </a>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <li *ngIf="loggedInUserService.isDisplaySeenEmployeeManagement()">
                        <a class="dropdown-item" [routerLink]="'empolyee-managment'" (click)="isCollapsed = !isCollapsed">
                            {{ 'empolyeeManagement' | translate }}
                        </a>
                    </li>
                    <li *ngIf="loggedInUserService.isSuperAdmin()">
                        <a class="dropdown-item" [routerLink]="'data-management'" (click)="onMenuClick(dataManagementRoute)">
                            {{ 'platformManagement' | translate }}
                        </a>
                    </li>
                    <li *ngIf="loggedInUserService.IsUserRelatedQualityAssurance()">
                        <a class="dropdown-item" [routerLink]="'call-center-client-management'" (click)="onMenuClick(callCenterClientManagementRoute)">
                            {{ 'callCenterClientManagement' | translate }}
                        </a>
                    </li>
                    <li *ngIf="userRole === userRoleEmpolyee">
                        <div class="d-flex align-items-center gap-3">
                            <span> {{ 'status' | translate }}</span>
                            <span [ngClass]="{ checked: checked === true, unchecked: checked === false }">{{ statusText | translate }}</span>
                            <mat-slide-toggle (change)="change($event)" [checked]="checked"></mat-slide-toggle>
                        </div>
                    </li>

                    <li *ngIf="otherLang$ | async as otherLang">
                        <a class="dropdown-item" (click)="switchLang(otherLang)">
                            <img src="assets/icons/lang.svg" class="img-size" />

                            {{ otherLang | translate }}</a
                        >
                    </li>
                    <!-- <li><hr class="dropdown-divider"></li> -->
                    <li>
                        <a class="dropdown-item logout" (click)="onLogout()">
                            <img src="assets/icons/logout.svg" class="img-size" />
                            {{ 'logout' | translate }}</a
                        >
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>
